import { HeadingXS } from '@/atoms/Text'
import { ReactFCC } from '@/types/react'

export const PageHeading: ReactFCC = ({ children }) => (
  <HeadingXS weight="bold" className="text-center text-xl md:text-3xl lg:text-4xl">
    {children}
  </HeadingXS>
)
